import { render, staticRenderFns } from "./AdminAccountTabPrivs.vue?vue&type=template&id=ae35f6ee&scoped=true&"
import script from "./AdminAccountTabPrivs.vue?vue&type=script&lang=js&"
export * from "./AdminAccountTabPrivs.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountTabPrivs.vue?vue&type=style&index=0&id=ae35f6ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae35f6ee",
  null
  
)

export default component.exports